<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong><i class="cui-graph icons font-2xl mt-4"></i>Master AWB  Tracking </strong>
            <div class="card-header-actions">       
                  
            </div>
          </div>  
          <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="8" >  
                  <b-col sm="12" >
                  <b-form-group  label="Master AWB / Shipping ID / Way Bill" :label-cols="5"> 
                   <b-form-input class="input" type="text" name="master_awb" v-model="customer.master_awb" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.master_awb') }" placeholder="Enter Master AWB / Shipping ID / Way Bill">
                   </b-form-input>
                    <span v-show="errors.has('form-1.master_awb')" class="help text-danger">{{ errors.first('form-1.master_awb') }}</span>
        <!--             <b-input-group class="mb-3">

                      <label class="radio-inline"><input type="radio" name="optradio" value="masterawb" checked v-model="trackingstatus"  @click="opentextfunction('master_awb')">&nbsp;Master AWB</label>&nbsp;&nbsp;
                      <label class="radio-inline"><input type="radio" name="optradio" value="shippingid" v-model="trackingstatus" @click="opentextfunction('shippingid')">&nbsp;Shipping Id</label>&nbsp;&nbsp;
                      
                      </b-input-group> -->
                     <!-- <b-form-radio-group
                      id="checkedtracking"
                      :options="options"
                      class="mb-3"
                      v-model="trackingstatus"
                      value-field="item"
                      text-field="name"
                      :aria-describedby="ariaDescribedby"
                      >
                     
                      </b-form-radio-group>
                      {{selected}} -->
                   </b-form-group>

                   </b-col>         
                </b-col> 
                <b-col md="4" >
                  <b-button type="submit" size="md" class="mr-4" variant="primary"> Search</b-button>
                  <b-button type="button" size="md" variant="danger" @click="clear()"> Clear</b-button>               
                </b-col>
              </b-row>  
            </form>
          </div>  
            <!--  -->
      <b-modal size="xl" v-model="showdhlexpress"  title="DHL Express" ok-only  >
        <!-- {{trackingnumber}} -->
        <!-- {{finaltrackinglink}} -->
         <div class="row md-12"> 
            <b-col md="12">
       <!-- src="https://mydhl.express.dhl/in/en/tracking.html#/results?id=trackingnumber"  -->
       
        <iframe  :src="finaltrackinglink"   width="100%" height="420px" title="DHL Express">
       </iframe>
            </b-col>
         </div>


       </b-modal>
           
          <div class="row md-12"> 
            <b-col md="12">
               <b-col md="12">
                 <button v-if="details.shipmenttrackingnumber != 'undefined' && details.shipmenttrackingnumber !=null && details.shipmenttrackingnumber !=''"  v-b-tooltip.hover title="DHL Express" class="btn btn-sm btn-primary mr-4 btn-pill" @click="DHLmodel(details.shipmenttrackingnumber)" style="float:right;"><i class="fa fa-television" aria-hidden="true"></i> &nbsp;DHL Express</button>  
                    <b-table show-empty   stacked="md" style="table-layout: fixed" :busy="isBusy" :outlined="outlined" :items="detailsitem" :bordered="bordered" :fields="detailsfield" caption-top>
               <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>

              <template slot="table-caption"><b>This is shipment tracking list</b></template>
          </b-table>
                 </b-col>
              </b-col>
             </div>

           <!--  <b-table show-empty stacked="md" style="table-layout: fixed"  :busy="isBusy" :items="ConsignmentMasterGetdata" :bordered="bordered" :fields="fields"   :outlined="outlined"  > -->

            <!--   <template slot="thead-top">
                  <div>
                  <b-modal id="bv-modal-example" hide-footer >
                    <template v-slot:modal-title>
                      <h3 style="margin-left: 180px;">Signature</h3>
                    </template>
                    <div class="d-block text-center">
                      <img alt="This image is not available" style="width: 458px;height: 250px;" v-bind:src="img1">  
                    </div>
                  </b-modal>
                </div>
                </template>
                <template slot="thead-top">
                  <div>
                  <b-modal id="bv-modal-example1" hide-footer >
                    <template v-slot:modal-title>
                      <h3 style="margin-left: 150px;">Shipment  Images</h3>
                    </template>
                          <template v-if="imgpath!=null">
                           <div class="d-block text-center" style="margin-bottom: 15px;" v-for="imgdata in imgpath">
                      <img alt="This image is not available" style="width: 458px;height: 250px;" v-bind:src="imgdata.imagepath">  
                    </div>
                          </template>
                          <template v-else>
                          <p>Image is not available</p>
                          </template>
                   
                   


                  </b-modal>
                </div>
                </template> -->
                <!-- <template slot="shippingidsign" slot-scope="row">
                   <b>Shipping ID:-</b><br> {{row.item.shippingid}}<br> 
                  <b>ORder ID:- </b><br> {{row.item.orderid}}
                 
                </template> -->
                <!-- <template slot="agentname" slot-scope="row">
                 {{row.item.agentname}}-{{row.item.deliveryagentmasterid}}
                 
                </template> -->
               <!--  <template slot="agentname" slot-scope="row">
                 {{row.item.shipmentstatus=="BookingPending" ? "-":row.item.agentname+"-"+row.item.deliveryagentmasterid}}
                 
                </template> -->
                <!--  <template slot="agentname" slot-scope="row">
                 {{row.item.deliveryagentmasterid == null ? row.item.agentname:row.item.agentname+"-"+row.item.deliveryagentmasterid}}
                 
                </template> -->
               <!--  <template slot="picklocation" slot-scope="row">
                   {{row.item.pickuplocationname}} &nbsp; --><!-- <span data-toggle="tooltip"  @click="$bvModal.show('bv-modal-example1')">
            <div v-if="row.item.shipmentstatus=='Delivered'" style="display: block;"> <i class="fa fa-picture-o" style="background-color: none;color: #20a8d8;"></i></div>
                  </span> -->
                  <!-- <span data-toggle="tooltip" >      
                  </span>
                </template> -->
                

            <!--   <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>           
            </b-table> -->

         <!--    <span style="color:red; float: right;" 
            v-if="is_mark_ofd==2"> 
              <b>Client Pick Cancel Request Received for this Shipment</b>
            </span> -->

           

           <!--  <div v-if="this.dlvstatus=='Delivered' || this.dlvstatus=='RTD'|| this.dlvstatus=='HandoverPending'">
             <span data-toggle="tooltip"  @click="$bvModal.show('bv-modal-example')">
              <label>View Signature</label>&nbsp;
             
             <i class="fa fa-pencil" style="background-color: none; color: #20a8d8;"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;|&nbsp;
             <span data-toggle="tooltip"  @click="$bvModal.show('bv-modal-example1')">
              <label>View Shipment Image</label>&nbsp;&nbsp;&nbsp;
              
               <i class="fa fa-picture-o" style="background-color: none;color: #20a8d8;"></i></span>

             </div> -->

         
          <div class="row md-12"> 
            <b-col md="12">
               <b-col md="12">
            <b-table show-empty   stacked="md" style="table-layout: fixed" :busy="isBusyshipmentlist" :outlined="outlined" :items="reverseitem" :bordered="bordered" :fields="reversefield" caption-top>
               <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>

              <template slot="table-caption"><b>This is shipment tracking list</b></template>
          </b-table>
        </b-col>
          </b-col>
          </div>
         

           <div class="row md-12"> 
            <b-col md="12">
               <b-col md="12">
            <b-table show-empty  hover stacked="md" style="table-layout: fixed" :busy="isBusyactivitylog" :outlined="outlined" :items="activitylogdata" :bordered="bordered" :fields="fieldlogdata" caption-top>
               <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              <template slot="table-caption"><b>Activity Log</b></template>
          </b-table>
        </b-col>
          </b-col>
          </div>

          <br>


         <!--  <div v-if="logistic == 'Shippments not found In Master Awb'">
            
          
           <div class="row md-12"> 
            <b-col md="12">
               <b-col md="12">
          <div v-model="logmodal">
            <b>Status For Logistics</b>
            <br>
            <br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#e84118" >
              {{logistic}}
            </span>
          </div>
           </b-col>
          </b-col>

          </div>
          </div> -->

          <!-- <div v-else> -->
            
          <div class="row md-12"> 
              <b-col md="12">
                 <b-col md="12">
             <b-table show-empty :busy="isBusylogistic" hover stacked="md" style="table-layout: fixed" :outlined="outlined" :items="logisticlogdata" :bordered="bordered" :fields="statusdata" caption-top>
               <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              <template slot="table-caption"><b>Status For Logistics</b></template>
             <!--  <template slot="pushflag" slot-scope="row">

                <span>{{ (row.item.pushflag==0)?'-':(row.item.pushflag==1)?'Success':'Fail'}} </span> 
                
                </template> -->
            </b-table>
          </b-col>
          </b-col>
        </div>
      <!-- </div> -->
            <div class="row md-12"> 
              <b-col md="12">
               <b-col md="12">
            <b-table show-empty  :busy="isBusyCustom" hover stacked="md" style="table-layout: fixed" :outlined="outlined" :items="customlogdata" :bordered="bordered" :fields="customFields" caption-top>
               <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              <template slot="table-caption"><b>Status For Custom</b></template>
              <!-- <template slot="pushflag" slot-scope="row"> -->
                  
              <!--   <span>{{ (row.item.pushflag==0)?'-':(row.item.pushflag==1)?'Success':'Fail'}} </span>  -->
                
                <!-- </template> -->
            </b-table>
             </b-col>
          </b-col>
          </div>

         <!-- Table for DHL Tracking -->

          <div class="row md-12" > 
              <b-col md="12">
               <b-col md="12">
            <b-table show-empty :busy="isBusydhltracking" hover stacked="md" style="table-layout: fixed" :outlined="outlined" :items="dhltrackingdata" :bordered="bordered" :fields="dhltrackingfields" caption-top>
               <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              <template slot="table-caption">
                <b>DHL Tracking</b></template>

            </b-table>
             </b-col>
          </b-col>
          </div>

          <!-- New Table for reverse shipment -->
            <!--     <div class="row md-12"> 
              <b-col md="12">
               <b-col md="12">
            <b-table show-empty  hover stacked="md" style="table-layout: fixed" :outlined="outlined" :items="reverseitem" :bordered="bordered" :fields="reversefield" caption-top>
              <template slot="table-caption"><b> Shipment List</b></template>
            </b-table>
             </b-col>
          </b-col>
          </div>

 -->




             <!--   <b-table show-empty  hover stacked="md" style="table-layout: fixed" :outlined="outlined" :items="smslogdata" :bordered="bordered" :fields="smsFields" caption-top>
              <template slot="table-caption"><b>Status For SMS</b></template>
              <template slot="issmssent" slot-scope="row">
                
                <span>{{ (row.item.is_sms_sent!=0)?'Delivered':'Pending'}} </span> 
                
                </template>
            </b-table> -->
        </b-card>
      </b-col>
    </b-row>      
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function () {
    return {
      awbmodal:false,
      isBusy: false,
      isBusydhltracking:false,
      customer: {},
      outlined:true,
      bordered: true,
      data: [],
      items: [],
      showdhlexpress:false,
      status_value: '',
      trackingstatus:'',
      selected_id_type:'',
      trackingnumber:'',
      finaltrackinglink:'',
      // selected:'',
      // options: [
      // { item: 'master_awb', name: 'Master Awb' },
      // { item: 'shippingid', name: 'Shipping ID' },
      // ],
      dlvstatus:[],
      img1:[],
      details:[],
      is_mark_ofd:0,
      imgpath:[],
      urlImg: [],
       customlogdata: [],
       isBusyCustom:false,
        smslogdata: [],
      //   dhlfields:[ 
      //   {key:'shipperreference' , label:'Shipper Reference' },
      // //  {key:'created_datetime' , label: 'Date'},
      // //   {key:'transport_mode' , label: 'Mode Of Transport'},
      // // {key:'return_response' , label: 'Response' },
      // ],
      customFields:[
      {key:'masterAwb' , label:'Master AWB' },
       {key:'created_datetime' , label: 'Date'},
        {key:'transport_mode' , label: 'Mode Of Transport'},
      {key:'return_response' , label: 'Response' },
     
     ],
     fieldlogdata:[
     {key:'master_awb' , label:'Master AWB' },
       // {key:'consolidate_invoiceno' , label: 'Consolidate Invoice'},
       //  {key: 'gp_no',label:'GP NO'}, 
        {key: 'created_by',label:'Created By'}, 
       {key: 'created_date',label:'Created Date'}, 
        // {key: 'country',label:'CountryCode'},
        // {key:'transport_mode' , label: 'ModeOfTransport'},
       
        {key: 'updated_date',label:'Updated Date'},
        {key: 'status',label:'Status'}, 

     ],
     logmodal:false,
     isBusylogistic:false,
      logisticlogdata: [],
      logistic:'',
      isBusyactivitylog:false,
      activitylogdata:[],
      activitylog:'',
      shipmentdata:[],
      dhltrackingdata:[],
      shippernumber:'',
      dhltrackingfields:[
      {key: 'shipperreference', label: 'Shipper Reference'},
      {key: 'airwaybillno', label: 'Airway Number '},
      {key: 'statuscode', label: 'Status Code'},
       {key: 'statusdescription', label: 'Description'},
      {key: 'pickupdate', label: 'PickUp Date'},
      {key: 'line_type', label: 'Line Type'},
      {key: 'deliverydate', label: 'Delivery Date'},

      ],
      // fields: [
      // {key: 'shippingid', label: 'ShippingID'},
      // {key: 'master_awb', label: 'MasterAWB'}, 
      // {key: 'consolidate_invoiceno',label:'Invoice'},
      // {key: 'invoice_generated_date',label:'InvoiceDate'}, 
      //  {key: 'gp_no',label:'GP NO'},  
      //  {key: 'country',label:'CountryCode'}, 
      //   {key: 'transport_mode',label:'ModeOfTransport'}, 
      //    {key: 'created_date',label:'Created'}, 
      //     {key: 'status',label:'Status'}, 

      // ],
       statusdata:[
        {key: 'shippingid', label: 'Shipping ID'},
        {key: 'courierstatus', label: 'Courier Status'},
        {key: 'createddate', label: 'Created Date'},
        {key:'pushflag' , label:'Status' }, 
        {key:'return_response' , label:'Response' }
        ],
      fielddata:[
        {key: 'shippingid', label: 'Shipping ID'},
      {key: 'master_awb', label: 'Master AWB'},  
       {key: 'country',label:'Country Code'}, 
        {key: 'transport_mode',label:'Mode Of Transport'}, 
          {key: 'shipmentstatus',label:'Shipment Status'}, 
          {key: 'deliverystatus',label:'Delivery Status'}, 
       ],
      smsFields:[
      {key:'shippingid' , label:'Shipping ID' },
      {key:'mobilenumber' , label: 'Mobile Number' },
      {key:'smsapiresponse' , label:'Sms Api Response' },
      {key:'issmssent' , label: 'SMS Sending Status'},
      {key:'sms_sent_date' , label:'SMS Sent Date' },
      {key:'action' , label:'Action' }],
      ConsignmentMasterGetdata: [],
      isConsignmentActivityTrackingGetWeb: 0,
      isConsignmentMasterGetStatus: 0,
      isGetlogisticlogdetails: 0,
      awb_length:0,
      isBusyshipmentlist:false,
      reverseitem:[],
      reversefield:[
      {key:'shippingid' , label:'Shipping Id' },
       {key:'orderid' , label: 'Order ID'},
         {key:'shipmentstatus' , label: 'Shipment Status'},
          {key:'deliverystatus' , label: 'Delivery Status'},
           {key:'created_date' , label: 'Created Date'},
           {key:'lastmodifieddate' , label: 'Modified Date'},
          
            {key:'pickuptype' , label: 'Pickup Type'},
             {key:'countrycode' , label: 'Country' },
        {key:'modeoftransport' , label: 'Mode Of Transport'},
        {key:'servicetype' , label: 'Service Type' },
     
     ],
     detailsitem:[],
     detailsfield:[
       {key:'master_awb' , label:'Master AWB' },
       {key:'country' , label: 'Country'},
       {key:'transport_mode' , label: 'Mode Of Transport'},
       {key:'shipmenttrackingnumber' , label: 'Shipment Tracking Number'},
       {key:'status' , label: 'Status'},
           
    ],

    }
  },
  created: function () {
    
  },
  methods: {
    validateForm(scope) {
     
      // var searchvaluesarr = []
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
         
          var master_awb = this.customer.master_awb
        
          // var searchvalues = master_awb.split(',')
          // for (var i = 0; i < searchvalues.length; i++) {
          //   searchvaluesarr.push(`${searchvalues[i]}`)
          // }
           var userdata = localStorage.getItem('userData')
       var userInfo = JSON.parse(userdata) 
          const customerGetAllobj = {
            master_awb: master_awb
          }


          // this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getmasterawbdetails`, customerGetAllobj)
          //   .then((result) => {
          //     // console.log('data result',result)
          //     if (result.body.returnmsg && result.body.returnmsg === 'UnSuccessful') {
          //       this.data = []
          //       //alert('Result not found')
          //       this.isConsignmentActivityTrackingGetWeb = 1
          //       // var searchlisting = document.getElementById('searchlisting')
          //       // searchlisting.style.display = 'block'
          //     } else if (result.body.length === 0) {
          //       //alert('Result not found')
          //       this.data = []
          //       this.isConsignmentActivityTrackingGetWeb = 1
          //       // var searchlisting = document.getElementById('searchlisting')
          //       // searchlisting.style.display = 'block'
          //     } else {
          //       this.data = result.body
          //       this.isConsignmentActivityTrackingGetWeb = 1
          //       // var searchlisting = document.getElementById('searchlisting')
          //       // searchlisting.style.display = 'block'
          //     }
          //   })
          //   .catch((ex) => {
          //     console.log('error', ex)
          //   })


          // Added By Sachin On 06/02/2020  
          //  var shipmentidget = this.customer.master_awb;
          // const customerstatusobj = {
          //   master_awb: `${shipmentidget}`
          // }
          // this.isBusy = true;
          // this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getmasterawbdetails`, customerstatusobj).then((result) => {
          //     // if (result.body.returnvalue.shipment_list.length > 0) 
          //      if (result.body.returnmsg==='Successful'){
                
          //       this.shipmentdata = result.body.returnvalue.shipment_list;
          //       //conole.log("this.logisticlogdata",this.logisticlogdata);
          //       this.isGetlogisticlogdetails = 1
          //       this.isBusy =false
                
          //     } else {
          //       //alert('Result not found')
          //       this.shipmentdata = []
          //       this.isGetlogisticlogdetails = 1
          //       this.isBusy = false

                
          //     }
          //   })
          //   .catch((ex) => {
          //     console.log('error', ex)
          //   })
            // Added By Sachin On 06/02/2020

            // Added By Sachin On 10/04/2020  
          var shipmentidget = this.customer.master_awb;
           this.isBusylogistic = true;
          const logisticobj = {
            masterAwb: `${shipmentidget}`
          }
          // this.isBusy = true;
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/logisticShipmentCheck`, logisticobj).then((result) => {
            // console.log('hiii',result);
              // if (result.body.returnvalue.length > 0){
              if (result.body.returnmsg==='Successful'){
                // alert('innn');
                // logmodal=true;
                this.logisticlogdata = result.body.returnvalue;
                // console.log("this.customlogdata",this.customlogdata);
                this.isBusylogistic = !this.isBusylogistic
                this.isGetlogisticlogdetails = 1
                // this.isBusy = false
                
              } else {
                //alert('Result not found')
                this.logistic = result.body.returnvalue;
                this.isGetlogisticlogdetails = 1;
                this.logisticlogdata=[];
                this.isBusylogistic = false;
                
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
          // Added By Sachin On 06/02/2020

            // Added By Sachin On 10/04/2020  
          var shipmentidget = this.customer.master_awb;
           this.isBusyCustom = true;
          const customobj = {
            masterAwb: `${shipmentidget}`
          }
          // this.isBusy = true;
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/statusforMasterawbcustom`, customobj).then((result) => {
            // console.log('hiii',result);
              // if (result.body.returnvalue.length > 0){
              if (result.body.returnmsg==='Successful'){
                // alert('innn');
                this.customlogdata = result.body.returnvalue;
                // console.log("this.customlogdata",this.customlogdata);
                this.isGetlogisticlogdetails = 1
               this.isBusyCustom = !this.isBusyCustom
                
              } else {
                //alert('Result not found')
                this.customlogdata = [];
                this.isGetlogisticlogdetails = 1
                this.isBusyCustom = false;
                
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
          // Added By Nazafat on 05/04/21
          var shipmentidget = this.customer.master_awb;
           this.isBusyactivitylog = true;
          const logobj = {
            master_awb: `${shipmentidget}`
          }
          // this.isBusy = true;
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getmasterawblog`, logobj).then((result) => {
             if (result.body.returnmsg==='Successful'){
                
                this.activitylogdata = result.body.returnvalue;
                //conole.log("this.logisticlogdata",this.logisticlogdata);
                this.isGetlogisticlogdetails = 1
               this.isBusyactivitylog = !this.isBusyactivitylog
                
              } else {
                //alert('Result not found')
                // this.activitylog = result.body.returnvalue;
                this.activitylogdata=[];
                this.isGetlogisticlogdetails = 1
                this.isBusyactivitylog = false

                
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })


            // Added By Nazafat on 01/07/21
          var shipmentidget = this.customer.master_awb;
           this.isBusyshipmentlist = true;
          const revobj = {
            master_awb: `${shipmentidget}`
          }
          // console.log("revobj",revobj);
          // return false;
          // this.isBusy = true;
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getshipmentlistofmasterawb`,revobj).then((result) => {
            // console.log("Result",result);
             if (result.body.returnmsg==='Successful'){
                
                this.reverseitem = result.body.returnvalue;
                // console.log(" this.reversefield", this.reverseitem);
                this.isGetlogisticlogdetails = 1
                this.isBusyshipmentlist = !this.isBusyshipmentlist;
                
              } else {
                //alert('Result not found')
                // this.activitylog = result.body.returnvalue;
                 this.reverseitem=[];
                this.isGetlogisticlogdetails = 1
                this.isBusyshipmentlist = false

                
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })









          //   var shippingid = this.customer.shipmentid;
          
          // const smsobj = {
          // shippingid: `${shippingid}`
          // }
          // this.isBusy = true;
          // this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/displaysmslog`, smsobj).then((result) => {
          //     if (result.body.returnvalue.length > 0) {
                
          //       this.smslogdata = result.body.returnvalue
          //       //conole.log("this.customlogdata",this.customlogdata);
          //       this.isGetlogisticlogdetails = 1
          //       this.isBusy = false
                
          //     } else {
          //       //alert('Result not found')
          //       this.smslogdata = []
          //       this.isGetlogisticlogdetails = 1
          //       this.isBusy = false;
                
          //     }
          //   })
          //   .catch((ex) => {
          //     console.log('error', ex)
          //   })
            //end   






          var shipmentidget = this.customer.master_awb;
           this.isBusy = true;
          const Getobj = {
            master_awb: `${shipmentidget}`,
           hub_id:`${userInfo.pickuplocationmasterid}`,
          }

         // this.isBusy = true;
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getmasterawbdetails`, Getobj)
            .then((result) => {

          
              if (result.body.returnmsg==='Successful') {
                // alert('innnn');
                this.awbmodal=true;
                // this.ConsignmentMasterGetdata = result.body.returnvalue.shipment_list;
                this.detailsitem=result.body.returnvalue.master_awb_details;
                this.details=result.body.returnvalue.master_awb_details[0];
                // console.log("Details", this.detailsitem);
                this.awb_length=1;
                this.isBusy = !this.isBusy
                // console.log('uuuu', this.awb_length);
            // this.is_mark_ofd=this.ConsignmentMasterGetdata[0].is_mark_ofd
                // alert(this.ConsignmentMasterGetdata[0].is_mark_ofd);
                // this.img1 = result.body[0].vendorsign
                // this.dlvstatus = result.body[0].shipmentstatus
                
                // this.urlImg = result.body[0].shipment_images
                // this.imgpath= JSON.parse(this.urlImg);
                
                this.isConsignmentMasterGetStatus = 1

                // this.isBusy = false;
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              } else {
                //alert('Result not found')
                this.ConsignmentMasterGetdata = []
                this.isConsignmentMasterGetStatus = 1
                // this.isBusy = false;
                this.awbmodal=false;
                 // this.details=[];
                 this.detailsitem=[];
                 this.isBusy = false;
                 this.awb_length=0;
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })

              // Added By Nazafat on 18/08/21
          var shipmentidget = this.customer.master_awb;

           this.isBusydhltracking = true;
          const dhlobj = {
            master_awb: `${shipmentidget}`
          }
          // console.log("revobj",revobj);
          // return false;
          // this.isBusy = true;
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdhlstatusaginstmasterawb`,dhlobj).then((result) => {
            // console.log("Result",result);
             if (result.body.returnmsg==='Successful'){
                
                this.dhltrackingdata = result.body.returnvalue;
                this.shippernumber=result.body.returnvalue[0].shipperreference;
                // console.log(" this.shippernumber",  this.shippernumber);
                // this.isGetlogisticlogdetails = 1
              this.isBusydhltracking = !this.isBusydhltracking
                
              } else {
                //alert('Result not found')
                // this.activitylog = result.body.returnvalue;
                 this.dhltrackingdata=[];
                // this.isGetlogisticlogdetails = 1
                this.isBusydhltracking = false;

                
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })

          }
         
      })
    },
    DHLmodel:function(value){
      // alert('innn');
      // console.log("bbbbbb",value);
      this.trackingnumber=parseInt(value);
        // this.trackingnumber=value;
      // console.log("trackingnumber",this.trackingnumber);
        var dhllink="https://mydhl.express.dhl/in/en/tracking.html#/results?id=";
    this.finaltrackinglink=dhllink + this.trackingnumber;
    // console.log("finaltrackinglink",this.finaltrackinglink);
       this.showdhlexpress =! this.showdhlexpress
    },
     opentextfunction: function(value){
          // alert(value);
          this.selected_id_type=value;
          // console.log("Value",value);
          //  console.log("idddd",id);
          this.status_value= value;
          
        },
    clear: function() {
      // alert('in cl')
      this.customer = {}
      this.trackingstatus=''
      this.errors.clear('form-1')
      this.dhltrackingdata=[];
      this.reverseitem=[];
      this.activitylogdata=[];
        this.logisticlogdata=[];
        this.customlogdata = [];
         this.details=[];
         this.detailsitem=[];
          this.awb_length=0;
      // var searchlisting = document.getElementById('searchlisting')
      // searchlisting.style.display = 'none'
      // var searchlisting2 = document.getElementById('searchlisting2')
      // searchlisting2.style.display = 'none'
    }
  },

  filters: {
    datechange: function (value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    }
  }
};
</script>
<style>
  .b-table-caption-top{
    color: black;
  }

.row {
    display: flex;
    flex-wrap: wrap;
    /* margin-right: -15px; */
    /* margin-left: -15px; */
}
.shipping table, th, td {
    border: 1px solid #c8ced3;
    border-collapse: collapse;
}
</style>
